var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgLegendBuilderDatetimei = function SvgLegendBuilderDatetimei(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: props.color || 'currentColor',
    rx: 2
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 13.5H16V17h-3.5z",
    "data-name": "Path 4842"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 6h-1v1.5a1 1 0 0 1-2 0V6a1 1 0 0 0 1 1 .945.945 0 0 0 1-1V5a1 1 0 0 0-2 0v1H9v1.5a1 1 0 0 1-2 0V6a1 1 0 0 0 1 1 .945.945 0 0 0 1-1V5a1 1 0 0 0-2 0v1H6a.945.945 0 0 0-1 1v11a2.006 2.006 0 0 0 2 2h10a2 2 0 0 0 2-2V7a.945.945 0 0 0-1-1zm-.4 11.6a.945.945 0 0 1-1 1H7.4a.945.945 0 0 1-1-1V10h11.2z",
    "data-name": "Path 4843"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLegendBuilderDatetimei);
export default ForwardRef;